import React from 'react'
import { Link, useSearchParams } from 'react-router-dom'

const PaymentSuccess = () => {
    const seachQuery = useSearchParams()[0]

    const referenceNum = seachQuery.get("reference")
    
  return (
    <div className='h-screen font-bold text-3xl flex justify-center items-center flex-col'>
        Thank You for donating to us! <br />
        <span className='text-2xl'>this is your reference id <Link to={"/posts"}><span className='text-blue-400'>{referenceNum}</span></Link></span>
    </div>
    
  )
}

export default PaymentSuccess